import { createRef, Fragment, Component } from "react"

import { ServiceType } from "../../../utils/helpers"
import { isSubsequentSession } from "../../../utils"
import { Discount } from "../../discount"
import { formatPrice } from "../../../utils/utils"
import { CURRENCY } from "../../../utils/constants"
import { Headline4, Button } from "../../../ui-kit/components-branded/index"

class CollapsibleInformation extends Component {
    state = {
        collapsed: true,
    }

    render() {
        return (
            <>
                {this.props.showButton && (
                    <i
                        className="far fa-question-circle"
                        onClick={this.toggleInformationVisibility}
                    />
                )}
                {!this.state.collapsed && this.props.children}
            </>
        )
    }

    toggleInformationVisibility = () => this.setState({ collapsed: !this.state.collapsed })
}

export class LocationSelect extends Component {
    state = {
        currentService: null,
    }

    setCurrentService = (service) => {
        this.setState({ currentService: service })
    }

    selectService = () => {
        if (!this.state.currentService) {
            return
        }

        this.props.onChange(this.state.currentService)
    }

    isButtonDisabled() {
        return !this.state.currentService
    }

    render() {
        const offered_services = this.props.offered_services || this.props.psy.offered_services
        const discount = new Discount(this.props.psy.discount)
        return (
            <div className="booking-options">
                <hr />
                <Headline4>Как бы вы хотели провести сессию:</Headline4>
                {offered_services.map((offeredService) => {
                    const serviceType = new ServiceType(offeredService)
                    const name = serviceType.displayStr()
                    const refServiceDescription = createRef()
                    const price =
                        isSubsequentSession() && offeredService.old_price
                            ? offeredService.old_price
                            : offeredService.price
                    let offeredServiceDiscount
                    let priceBeforeDiscount = offeredService.price

                    /**
                     * @todo
                     *
                     * remove old_price with related code when quarantine ends
                     */

                    if (this.props.psy.discount) {
                        offeredServiceDiscount = discount
                    } else if (offeredService.old_price && !isSubsequentSession()) {
                        priceBeforeDiscount = offeredService.old_price
                        offeredServiceDiscount = new Discount({
                            flat: offeredService.old_price - offeredService.price,
                        })
                    }

                    return (
                        <Fragment key={offeredService.id}>
                            <div className="custom-control custom-radio">
                                <input
                                    type="radio"
                                    className="custom-control-input"
                                    id={name}
                                    name="service"
                                    value={serviceType.id}
                                    onChange={() => this.setCurrentService(offeredService)}
                                />
                                <label className="custom-control-label" htmlFor={name}>
                                    <strong>
                                        {name}
                                        {this.props.showPrice && (
                                            <>
                                                {" – "}
                                                {!offeredServiceDiscount ? (
                                                    formatPrice(price, CURRENCY.RUB)
                                                ) : (
                                                    <>
                                                        <span className="non-discount-price">
                                                            {formatPrice(
                                                                priceBeforeDiscount,
                                                                CURRENCY.RUB
                                                            )}
                                                        </span>
                                                        <span className="discount-price">
                                                            {" "}
                                                            {offeredServiceDiscount.apply(
                                                                priceBeforeDiscount
                                                            )}{" "}
                                                            ₽{" "}
                                                            {offeredService.old_price &&
                                                                !this.props.psy.discount &&
                                                                "(скидка только для новых клиентов)"}
                                                        </span>
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </strong>
                                </label>
                                {serviceType.description && (
                                    <i
                                        className="fas fa-info-circle ml-auto collapsible-information-button"
                                        onClick={() => {
                                            if (refServiceDescription.current) {
                                                refServiceDescription.current.toggleInformationVisibility()
                                            }
                                        }}
                                    />
                                )}
                            </div>
                            {serviceType.description && (
                                <CollapsibleInformation ref={refServiceDescription}>
                                    <div
                                        className="collapsible-information-text"
                                        onClick={() =>
                                            refServiceDescription.current.toggleInformationVisibility()
                                        }
                                    >
                                        {serviceType.description}
                                    </div>
                                </CollapsibleInformation>
                            )}
                            {serviceType.online || (
                                <div className="location-city-details">
                                    {this.props.psy.new_city.name}, {this.props.psy.city_details}
                                </div>
                            )}
                        </Fragment>
                    )
                })}
                <Button
                    isFullwidth
                    color="primary"
                    className="mt-3"
                    disabled={this.isButtonDisabled()}
                    onClick={this.selectService}
                >
                    Дальше
                </Button>
                <br />
                <br />
            </div>
        )
    }
}
